module.exports = __webpack_public_path__ + "static/media/learning-28.2817c427.png";